/**
 * CLASSIC_NAV — config-driven nav for the "Clio Classic" V1-faithful reporting
 * experience (ClioAdmin #71, Phase 4 / B1).
 *
 * Describes V1's top-level nav choices (Patient Experience / Reporting /
 * Service Recovery / Exports). The V2 left sidebar renders this array `*ngFor`
 * when `ClassicModeService.mode === 'classic'` — replacing the Phase-1
 * hand-maintained `*ngIf` rows. Making the Classic nav data-driven is the
 * enabler for a reusable V1⇄global nav toggle (per design-spec §0).
 *
 * `icon` follows the existing Apex menu's FontAwesome convention
 * (`fas fa-2x fa-fw <name>`). `route` matches the `/classic/*` children already
 * wired in app.routing.ts.
 */
export interface ClassicNavItem {
    /** Sidebar row label (V1 section name). */
    label: string;
    /** FontAwesome class string, matching the Apex menu icon convention. */
    icon: string;
    /** Absolute route under the /classic parent. */
    route: string;
}

export const CLASSIC_NAV: ClassicNavItem[] = [
    { label: "Patient Experience", icon: "fas fa-2x fa-fw fa-user-md", route: "/classic/patient-experience" },
    { label: "Reporting", icon: "fas fa-2x fa-fw fa-chart-bar", route: "/classic/reports" },
    { label: "Service Recovery", icon: "fas fa-2x fa-fw fa-life-ring", route: "/classic/service-recovery" },
    { label: "Exports", icon: "fas fa-2x fa-fw fa-download", route: "/classic/favorites" },
];
